var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.025 16.175 6.025 10.175 7.9 8.3 10.7 11.1V3.075H13.35V11.1L16.15 8.3L18.025 10.175ZM5.9 20.775Q4.8 20.775 4.025 20Q3.25 19.225 3.25 18.125V15.075H5.9V18.125Q5.9 18.125 5.9 18.125Q5.9 18.125 5.9 18.125H18.1Q18.1 18.125 18.1 18.125Q18.1 18.125 18.1 18.125V15.075H20.75V18.125Q20.75 19.225 19.975 20Q19.2 20.775 18.1 20.775Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.2898b8414e012f6ce1c644dd17e66af8.svg";
export { ForwardRef as ReactComponent };